import React, { useState, useEffect } from "react";
import { Upload, RefreshCw, CheckCircle, AlertCircle } from "lucide-react";
import SearchBar from "../common/SearchBar";
import { PrimaryButton } from "../common/ActionButtons";

const PushToGitHub = () => {
  const [workflows, setWorkflows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [pushing, setPushing] = useState(null);
  const [pushedWorkflows, setPushedWorkflows] = useState([]);

  const [githubConfig, setGithubConfig] = useState({
    owner: "",
    repo: "",
    branch: "main",
    token: "",
  });

  useEffect(() => {
    fetchWorkflows();
  }, []);

  const fetchWorkflows = async () => {
    setLoading(true);
    try {
      // TODO: Implement n8n API call
      // const response = await fetch('http://your-n8n-instance/api/v1/workflows', {
      //   headers: { 'X-N8N-API-KEY': 'your-api-key' }
      // });
      // const data = await response.json();
      // setWorkflows(data.data);

      console.log("Fetch workflows - implement n8n API");
    } catch (error) {
      console.error("Error fetching workflows:", error);
    }
    setLoading(false);
  };

  const pushToGitHub = async (workflow) => {
    if (!githubConfig.owner || !githubConfig.repo || !githubConfig.token) {
      alert("Please configure GitHub settings first (Owner, Repo, Token)");
      return;
    }

    setPushing(workflow.id);
    try {
      // TODO: Implement workflow export and GitHub push
      // Step 1: Get full workflow from n8n
      // const workflowResponse = await fetch(`http://your-n8n-instance/api/v1/workflows/${workflow.id}`, {
      //   headers: { 'X-N8N-API-KEY': 'your-api-key' }
      // });
      // const workflowData = await workflowResponse.json();

      // Step 2: Convert to JSON
      // const workflowJson = JSON.stringify(workflowData.data, null, 2);

      // Step 3: Push to GitHub
      // const githubPath = `workflows/${workflow.name.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.json`;
      // const githubUrl = `https://api.github.com/repos/${githubConfig.owner}/${githubConfig.repo}/contents/${githubPath}`;

      // Check if file exists
      // let sha = null;
      // try {
      //   const existingFile = await fetch(githubUrl, {
      //     headers: { 'Authorization': `token ${githubConfig.token}` }
      //   });
      //   if (existingFile.ok) {
      //     const fileData = await existingFile.json();
      //     sha = fileData.sha;
      //   }
      // } catch (e) {}

      // Create or update file
      // const pushResponse = await fetch(githubUrl, {
      //   method: 'PUT',
      //   headers: {
      //     'Authorization': `token ${githubConfig.token}`,
      //     'Content-Type': 'application/json'
      //   },
      //   body: JSON.stringify({
      //     message: `Update workflow: ${workflow.name}`,
      //     content: btoa(workflowJson), // Base64 encode
      //     branch: githubConfig.branch,
      //     ...(sha && { sha })
      //   })
      // });

      console.log(
        `Push workflow ${workflow.id} to GitHub: ${githubConfig.owner}/${githubConfig.repo}`,
      );

      setPushedWorkflows((prev) => [...prev, workflow.id]);
    } catch (error) {
      console.error("Error pushing to GitHub:", error);
      alert("Failed to push workflow. Check console for details.");
    }
    setPushing(null);
  };

  const filteredWorkflows = workflows.filter(
    (workflow) =>
      workflow.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      workflow.id?.toString().includes(searchTerm),
  );

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Push to GitHub</h1>
          <p className="text-slate-600">
            Export n8n workflows to GitHub repository
          </p>
        </div>
        <PrimaryButton
          onClick={fetchWorkflows}
          icon={RefreshCw}
          disabled={loading}
        >
          {loading ? "Refreshing..." : "Refresh"}
        </PrimaryButton>
      </div>

      {/* GitHub Configuration */}
      <div className="bg-white rounded-lg shadow-md border border-slate-200 p-6">
        <h2 className="text-lg font-semibold text-slate-800 mb-4">
          GitHub Configuration
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Repository Owner *
            </label>
            <input
              type="text"
              value={githubConfig.owner}
              onChange={(e) =>
                setGithubConfig({ ...githubConfig, owner: e.target.value })
              }
              placeholder="username or organization"
              className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Repository Name *
            </label>
            <input
              type="text"
              value={githubConfig.repo}
              onChange={(e) =>
                setGithubConfig({ ...githubConfig, repo: e.target.value })
              }
              placeholder="n8n-workflows"
              className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Branch
            </label>
            <input
              type="text"
              value={githubConfig.branch}
              onChange={(e) =>
                setGithubConfig({ ...githubConfig, branch: e.target.value })
              }
              placeholder="main"
              className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">
              Personal Access Token *
            </label>
            <input
              type="password"
              value={githubConfig.token}
              onChange={(e) =>
                setGithubConfig({ ...githubConfig, token: e.target.value })
              }
              placeholder="ghp_..."
              className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        <p className="text-xs text-slate-500 mt-2">
          ⚠️ Create a personal access token with 'repo' scope at:
          <a
            href="https://github.com/settings/tokens"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline ml-1"
          >
            github.com/settings/tokens
          </a>
        </p>
      </div>

      <SearchBar
        value={searchTerm}
        onChange={setSearchTerm}
        onRefresh={fetchWorkflows}
        placeholder="Search workflows..."
      />

      <div className="bg-white rounded-lg shadow-md overflow-hidden border border-slate-200">
        <table className="min-w-full divide-y divide-slate-200">
          <thead className="bg-slate-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                ID
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                Last Updated
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-slate-200">
            {loading ? (
              <tr>
                <td
                  colSpan={5}
                  className="px-6 py-4 text-center text-slate-500"
                >
                  <div className="flex justify-center items-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  </div>
                </td>
              </tr>
            ) : filteredWorkflows.length === 0 ? (
              <tr>
                <td
                  colSpan={5}
                  className="px-6 py-4 text-center text-slate-500"
                >
                  No workflows found. Connect to your n8n instance to see
                  workflows.
                </td>
              </tr>
            ) : (
              filteredWorkflows.map((workflow) => {
                const isPushing = pushing === workflow.id;
                const wasPushed = pushedWorkflows.includes(workflow.id);

                return (
                  <tr key={workflow.id} className="hover:bg-slate-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600">
                      {workflow.id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
                      {workflow.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className={`px-2 py-1 text-xs font-medium rounded-full ${
                          workflow.active
                            ? "bg-green-100 text-green-800"
                            : "bg-slate-100 text-slate-800"
                        }`}
                      >
                        {workflow.active ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600">
                      {workflow.updatedAt
                        ? new Date(workflow.updatedAt).toLocaleString()
                        : "Never"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <div className="flex items-center space-x-2">
                        {wasPushed && !isPushing && (
                          <div className="flex items-center text-green-600 text-xs mr-2">
                            <CheckCircle className="w-4 h-4 mr-1" />
                            Pushed!
                          </div>
                        )}
                        <button
                          onClick={() => pushToGitHub(workflow)}
                          disabled={isPushing}
                          className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
                            isPushing
                              ? "bg-slate-100 text-slate-400 cursor-not-allowed"
                              : "bg-blue-600 text-white hover:bg-blue-700"
                          }`}
                        >
                          {isPushing ? (
                            <>
                              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                              Pushing...
                            </>
                          ) : (
                            <>
                              <Upload className="w-4 h-4" />
                              Push to GitHub
                            </>
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h3 className="text-sm font-semibold text-blue-900 mb-2">
            📦 What Gets Pushed
          </h3>
          <ul className="text-sm text-blue-800 space-y-1 ml-4 list-disc">
            <li>Complete workflow JSON including all nodes</li>
            <li>Workflow configuration and settings</li>
            <li>Node connections and parameters</li>
            <li>
              Saved to:{" "}
              <code className="bg-blue-100 px-1 rounded">
                workflows/workflow-name.json
              </code>
            </li>
          </ul>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
          <h3 className="text-sm font-semibold text-amber-900 mb-2">
            ⚠️ Important Notes
          </h3>
          <ul className="text-sm text-amber-800 space-y-1 ml-4 list-disc">
            <li>Credentials are NOT included (for security)</li>
            <li>Token needs 'repo' scope permissions</li>
            <li>Files will be created/updated automatically</li>
            <li>Existing files will be overwritten</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PushToGitHub;
